
import {useStore} from 'vuex'
import {computed,ref,reactive} from 'vue'
import { clickOutsideElement } from '../../foundation/js/clickoutside'

import PriceToggle from '../PriceToggle/PriceToggle.vue'


export default {
    name: 'SiteNavigationMobile',
    components:{
        PriceToggle
    },
    setup(){
        const store = useStore()
        const menudata = computed(()=> store.getters['main/getMenuForMobile'])
        const serviceMenuData = computed(()=> store.state.main.service_menu_links)
        const countrySelectorData = computed(()=> store.state.main.country_selector_data.filter(lang => !lang.active))
        const activeLang = computed(()=> store.state.main.lang.displayValue)
        let langSelectorVisible = ref(false)
        const groups = {}

        for(let group in store.state.main.mega_menu_data){
            groups[group] = false
        }

        let groupsVisible = reactive(groups)
        let sublevelsVisible = reactive({})

        const toggleGroup = (groupId) => {
            groupsVisible[groupId] = !(groupsVisible[groupId])
        }

        const toggleSublevel = (sublevelId) => {
            sublevelsVisible[sublevelId] = !(sublevelsVisible[sublevelId])
        }

        const toggleCountrySelector = () =>{
            langSelectorVisible.value = !langSelectorVisible.value

            if(langSelectorVisible.value) clickOutsideElement(closeCountrySelector,'.nlx-site-navigation-mobile')()
        }

        const closeCountrySelector = () =>{
            langSelectorVisible.value = false
        }

        return {
            activeLang,
            countrySelectorData,
            langSelectorVisible,
            menudata,
            groupsVisible,
            toggleGroup,
            toggleCountrySelector,
            serviceMenuData,
            toggleSublevel,
            sublevelsVisible
        }

    }
}